var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.labels),function(label){return _c('span',{key:label.title,style:(_vm.getStyle(label.color))},[_vm._v("\n    "+_vm._s(label.title)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }